
import React from 'react'
import './css/Politica.css'
import './css/About.css'
const Politica = () => {
  return (
    <div class="page-about politica">
    <div className='about-page page pt-5 mt-3'>
    <div className='row px-lg-5 ms-lg-0 about-content'>
      
      <div className='col-lg-1'>
      </div>
      <div className='col-lg-10 '>
  <section className='section p-5 mx-lg-5 row '>
    <h1>Zásady bezpečnosti</h1>
    <p>Vaše bezpečnost a ochrana dat jsou pro nás prioritou. Tyto zásady bezpečnosti vysvětlují, jakým způsobem chráníme informace, které nám poskytujete při používání našich webových stránek.</p>

    <h5>1. Shromažďování informací</h5>
    <ul>
      <li>Kontaktní údaje (jméno, e-mail, telefon)</li>
      <li>Technické údaje o zařízení a prohlížeči</li>
      <li>Informace o chování na stránkách (např. cookies, IP adresa)</li>
    </ul>

    <h5>2. Použití informací</h5>
    <ul>
      <li>Poskytování našich služeb</li>
      <li>Zlepšování uživatelského prostředí</li>
      <li>Komunikaci se zákazníky</li>
      <li>Zajištění bezpečnosti webových stránek</li>
    </ul>

    <h5>3. Ochrana dat</h5>
    <ul>
      <li>Šifrování dat (např. SSL)</li>
      <li>Omezený přístup k informacím</li>
      <li>Pravidelné aktualizace systému</li>
    </ul>

    <h5>4. Sdílení informací</h5>
    <p>Vaše osobní údaje nesdílíme s třetími stranami, s výjimkou případů, kdy je to nezbytné pro poskytování našich služeb nebo pokud to vyžaduje zákon.</p>

    <h5>5. Práva uživatelů</h5>
    <ul>
      <li>Požádat o přístup ke svým údajům</li>
      <li>Požadovat opravu nebo výmaz údajů</li>
      <li>Vznést námitku proti zpracování údajů</li>
      <li>Odvolat souhlas se zpracováním údajů</li>
    </ul>

    <h5>6. Cookies</h5>
    <p>Naše stránky používají cookies pro analýzu návštěvnosti a zlepšení uživatelského zážitku. Používáním stránek souhlasíte s jejich použitím. Cookies můžete kdykoli upravit ve svém prohlížeči.</p>

    <h5>7. Změny v zásadách</h5>
    <p>Zásady bezpečnosti můžeme čas od času aktualizovat. Doporučujeme vám pravidelně kontrolovat tuto stránku.</p>

    <h5>Kontakt</h5>
    <p>Máte-li jakékoli dotazy týkající se bezpečnosti nebo ochrany vašich údajů, kontaktujte nás na e-mailu: <a href="">  </a></p>
  </section>
  </div>
    </div>
  </div>
  </div>
  )
}

export default Politica
